<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">

    <h3>Stock Crítico</h3>
    <br>
    <kuv-lazy-table url={{url_stock_critico_productos}}
        [urlExcel]="config.apiUrl + 'producto/excel-stock-critico'" [headersBlob]="sesion.headersBlob"
        [pageSize]="20" [headers]="sesion.headers" [reloadEmitter]="reloadEmitter" [filtros]="filtros"
        [columnas]="columnas" [acciones]="acciones" [useIndex]="true" [isRounded]="true"
        [hasShadow]="true"></kuv-lazy-table>
</div>